import { useCallback } from 'react';
import { useModalActions } from 'components/ModalManager/Context';
import { NodepoolCreationModal } from 'modules/Compute/Components/NodepoolCreationModal/NodepoolCreationModal';
import { noop } from 'utils/fp';
import { Formik } from 'formik';

export const useNodepoolCreationModal = () => {
  const { openModal, closeModal } = useModalActions();

  const openNodepoolCreationModal = useCallback(() => {
    const modalId = 'nodepool-creation-modal';

    openModal({
      id: modalId,
      title: 'Add Nodepool',
      content: (
        <Formik initialValues={{}} onSubmit={() => {}}>
          <NodepoolCreationModal onClose={() => closeModal({ id: modalId })} />
        </Formik>
      ),
      className: 'nodepool-creation-modal',
      makeActions: noop,
    });
  }, [openModal, closeModal]);

  return { openNodepoolCreationModal };
};
